<template>
  <div class="table">
    <div class="table_header">
      <slot name="header"></slot>
    </div>
    <div class="table_list">
      <el-table
        v-loading="loading"
        :data="tableList"
        style="width: 100%"
        size="small"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column v-if="showSelect" type="selection" width="55">
        </el-table-column>
        <template v-for="item in tableOptionList">
          <el-table-column
            v-if="item.slotName"
            :key="item.porp"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            v-bind="item.other"
          >
            <template slot-scope="scope">
              <slot :name="item.slotName" :row="scope.row"></slot>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.porp"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            v-bind="item.other"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="table_footer" v-if="showFooter">
      <slot name="footer">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :layout="layout"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => []
    },
    tableOptionList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 15
    },
    total: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper"
    }
  },
  data() {
    return {};
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/table/Table.vue